import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { LoggerService } from '../../services/logger.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly logger = inject(LoggerService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const user = this.authService.currentUser();
    const isAuthenticated = this.authService.isAuthenticated();
    const token = this.authService.getToken();

    this.logger.info('[AuthGuard] Checking access', {
      url: state.url,
      hasUser: !!user,
      isAuthenticated,
      hasToken: !!token,
    });

    if (user && isAuthenticated && token) {
      this.logger.info('[AuthGuard] Access granted to:', state.url);
      return true;
    }

    this.logger.warn('[AuthGuard] Access denied, redirecting to login', {
      url: state.url,
      hasUser: !!user,
      isAuthenticated,
      hasToken: !!token,
    });

    // Use auth service to properly clean up state
    this.authService.logout('inactivity').subscribe({
      next: () => {
        this.router.navigate(['/login'], {
          queryParams: { returnUrl: state.url },
        });
      },
      error: () => {
        // In case of error, redirect anyway
        this.router.navigate(['/login'], {
          queryParams: { returnUrl: state.url },
        });
      },
    });
    return false;
  }
}
